"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
function TabsButton(props) {
    const { count = 0, selected = false, disabled = false, className, onClick, } = props;
    return ((0, jsx_runtime_1.jsxs)(Container, { "$disabled": disabled, className: className, children: [(0, jsx_runtime_1.jsx)(Border, { selected: selected, name: ui_1.Icons.Tabs_Button_Border, width: 40, height: 40 }), (0, jsx_runtime_1.jsxs)(Button, { onClick: onClick, children: [(0, jsx_runtime_1.jsx)(SubContainer, { "$height": 18, children: (0, jsx_runtime_1.jsx)(Label, { "$active": selected, children: "TAB" }) }), (0, jsx_runtime_1.jsx)(SubContainer, { "$height": 22, children: selected ? ((0, jsx_runtime_1.jsx)(CancelIcon, { name: ui_1.Icons.Tabs_Button_Cancel, width: 7, height: 12 })) : ((0, jsx_runtime_1.jsx)(Counter, { children: count > 1 ? count : (0, jsx_runtime_1.jsx)(Plus, { children: "+" }) })) })] })] }));
}
exports.default = TabsButton;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;

  width: 40px;
  height: 40px;

  transition: opacity 0.2s ease-in-out;

  ${({ $disabled }) => $disabled &&
    (0, styled_components_1.css) `
      opacity: 0.2;
    `}
`;
const Button = (0, styled_components_1.default)(ui_1.BaseButton) `
  position: absolute;

  margin: 0;
  padding: 0;
`;
const Border = (0, styled_components_1.default)(ui_1.Icon) `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  color: ${({ selected, theme }) => selected ? theme.background : theme.tabs.button.borderColor};

  pointer-events: none;

  ${({ selected, theme }) => selected &&
    (0, styled_components_1.css) `
      filter: ${theme.tabs.button.activeBorderFilter};
    `}
`;
const SubContainer = styled_components_1.default.div `
  display: flex;

  width: 40px;
  height: ${({ $height }) => $height}px;
`;
const Label = styled_components_1.default.div `
  margin: auto auto 0 auto;
  padding: 0 5px 0 0;

  color: ${({ $active, theme }) => $active ? theme.text : theme.textSecondary};

  font-size: 10px;

  ${({ $active }) => $active &&
    (0, styled_components_1.css) `
      font-weight: bold;
    `}
`;
const Counter = styled_components_1.default.div `
  margin: 0 auto auto auto;
  padding: 0 5px 0 0;

  color: ${props => props.theme.textSecondary};

  font-weight: bold;
  font-size: 12px;
`;
const Plus = styled_components_1.default.span `
  font-size: 14px;
  line-height: 12px;
`;
const CancelIcon = (0, styled_components_1.default)(ui_1.Icon) `
  margin: 1px auto auto auto;
  padding: 0 5px 0 0;

  color: ${props => props.theme.text};
`;
